class MoreInfo extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if(this.closest('tr.CartDrawer-Item-0').classList.contains('show-items')){
        this.closest('tr.CartDrawer-Item-0').classList.remove('show-items');
        this.innerHTML = 'More info';
      }else{
        this.closest('tr.CartDrawer-Item-0').classList.add('show-items');
        this.innerHTML = 'Less info';
      }
    })
  }
}
customElements.define('more-info', MoreInfo);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState,checkOpen) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      // itg js
      if(!document.body.classList.contains('temp_page-build-box')){
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        if(checkOpen){}else{
          this.open();
        }
      }
      // itg js
      clickEvents();
      if(document.querySelector('.cart-gift-main .cart-gift input#cart__gift')){
        document.querySelector('.cart-gift-main .cart-gift input#cart__gift').onchange = function(){
          if(this.checked){
              document.querySelector('.cart-gift-main .cart_gift_note').style.display = 'block';
          }else{
              document.querySelector('textarea#cart_gift_note').value = '';
              document.querySelector('.cart-gift-main .cart_gift_note').style.display = 'none';
              clearGift();
          }
        }
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// itg js for swap box remove
async function removeSwapBox(removeBtn) {
  let swapBoxKey = removeBtn.dataset.key;
  let cartDrawer = document.querySelector('cart-drawer');
  if(removeBtn.dataset.index == 0){
    removeBtn.closest('tr.cart-item').querySelector('.loading__spinner').classList.remove('hidden');
  }
  let currentCart = await getCart();
  let obj = currentCart.items;
  let updates = {};
  let secData = [
    "cart-drawer",
    "cart-icon-bubble"
  ]
  
  for (let i = 0; i < obj.length; i++) {
    let proObj = obj[i]['properties']['_swapBoxId'] || obj[i]['properties']['_bulkBoxId'];
    if(proObj == swapBoxKey || obj[i]['properties']['_mainSwapBoxId'] == swapBoxKey || obj[i]['properties']['_mainBulkBoxId'] == swapBoxKey || obj[i].key == swapBoxKey){
      let Id = obj[i].key;
      updates[Id] = 0;
    }
  }
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 
      updates,
      sections: secData,
      sections_url: window.location.pathname
    })
  })
  .then(response => {
    return response.json();
  }).then(response => { 
    let cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);
    if (cartDrawer) cartDrawer.classList.toggle('is-empty', response.item_count === 0);
    cartDrawer.renderContents(response);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}